import { gql } from "graphql-tag";

/**
 * One row per mode: backend returns only the fields applicable to `report_mode`
 * (orders | by_address | address_group_orders | flat_line). Other fields are null.
 * For `address_group_orders`, `address_group_key` and optional `drilldown_orders` may be set.
 */
export const SHIPPING_ADDRESS_REPORT_ROW = gql`
  fragment ShippingAddressReportRow on ShippingAddressReportRow {
    path
    address_group_key
    drilldown_orders {
      order {
        id
        uuid
        name
        created_at
        path
      }
      order_grand_total
      order_lines {
        product_name
        quantity
        line_total
      }
    }
    customer {
      id
      uuid
      path
      user {
        name
        email
      }
    }
    order {
      id
      uuid
      name
      created_at
      path
    }
    shipping_address {
      name
      company
      address_1
      address_2
      city
      postal_code
      country {
        name
      }
    }
    order_count
    address_total
    order_grand_total
    line {
      product_name
      quantity
      line_total
    }
    order_lines {
      product_name
      quantity
      line_total
    }
  }
`;
